// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var IOUtils = require("../../../shared/src/IOUtils.bs.js");
var DomUtils = require("../../../shared/src/DomUtils.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var ReactUtils = require("../../../shared/src/ReactUtils.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../BrowserStyle.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var BrowserComponents_Field = require("./BrowserComponents_Field.bs.js");
var BrowserComponents_Input = require("./BrowserComponents_Input.bs.js");

function textarea(styleType) {
  return Curry._1(BrowserStyle.merge, {
              hd: Curry._2(BrowserComponents_Input.Base.Styles.input, /* Medium */2, styleType),
              tl: {
                hd: Curry._1(BrowserStyle.style, {
                      hd: BrowserStyle.resize(BrowserStyle.vertical),
                      tl: /* [] */0
                    }),
                tl: /* [] */0
              }
            });
}

var Styles = {
  textarea: textarea
};

var make = React.forwardRef(function (Props, ref_) {
      var autoFocusOpt = Props.autoFocus;
      var className = Props.className;
      var onBlurOpt = Props.onBlur;
      var onChange = Props.onChange;
      var onFocusOpt = Props.onFocus;
      var onKeyPressOpt = Props.onKeyPress;
      var placeholder = Props.placeholder;
      var requiredOpt = Props.required;
      var rows = Props.rows;
      var testId = Props.testId;
      var styleType = Props.styleType;
      var value = Props.value;
      var autoFocus = autoFocusOpt !== undefined ? autoFocusOpt : false;
      var onBlur = onBlurOpt !== undefined ? onBlurOpt : Relude_IO.pure(undefined);
      var onFocus = onFocusOpt !== undefined ? onFocusOpt : (function (param) {
            return Relude_Globals.$great$great((function (prim) {
                          
                        }), Relude_IO.pure, param);
          });
      var onKeyPress = onKeyPressOpt !== undefined ? onKeyPressOpt : (function (param) {
            return Relude_Globals.$great$great((function (prim) {
                          
                        }), Relude_IO.pure, param);
          });
      var required = requiredOpt !== undefined ? requiredOpt : false;
      var partial_arg = Relude_IO.pure(undefined);
      var partial_arg$1 = function (param) {
        return Relude_Option.fold(partial_arg, onKeyPress, param);
      };
      var partial_arg$2 = function (param) {
        return Relude_Globals.$great$great(DomUtils.KeyMappings.getKeyFromEvent, partial_arg$1, param);
      };
      var tmp = {
        className: BrowserStyle.Utils.extendBaseStyle(textarea(styleType), className),
        autoFocus: autoFocus,
        disabled: BrowserStyle.Input.isDisabled(styleType),
        required: required,
        value: value,
        onKeyPress: (function (param) {
            return Relude_Globals.$great$great(partial_arg$2, IOUtils.unsafeRunHandledAsync, param);
          }),
        onFocus: (function (param) {
            return Relude_Globals.$great$great((function (param) {
                          return Relude_Globals.$great$great(Relude_IO.pure, (function (param) {
                                        return Relude_IO.flatMap(onFocus, param);
                                      }), param);
                        }), IOUtils.unsafeRunHandledAsync, param);
          }),
        onBlur: (function (param) {
            return Relude_Globals.$great$great((function (param) {
                          return Relude_Globals.$$const(onBlur, param);
                        }), IOUtils.unsafeRunHandledAsync, param);
          }),
        onChange: (function (param) {
            return Relude_Globals.$great$great((function (param) {
                          return Relude_Globals.$great$great(DomUtils.getValueFromEvent, onChange, param);
                        }), IOUtils.unsafeRunHandledAsync, param);
          })
      };
      var tmp$1 = Relude_Option.map((function (prim) {
              return prim;
            }), (ref_ == null) ? undefined : Caml_option.some(ref_));
      if (tmp$1 !== undefined) {
        tmp.ref = Caml_option.valFromOption(tmp$1);
      }
      if (placeholder !== undefined) {
        tmp.placeholder = Caml_option.valFromOption(placeholder);
      }
      if (rows !== undefined) {
        tmp.rows = Caml_option.valFromOption(rows);
      }
      var tmp$2 = {
        children: React.createElement("textarea", tmp)
      };
      if (testId !== undefined) {
        tmp$2.id = Caml_option.valFromOption(testId);
      }
      return React.createElement(ReactUtils.WithTestId.make, tmp$2);
    });

var Base = {
  Styles: Styles,
  make: make
};

var make$1 = React.forwardRef(function (Props, ref_) {
      var autoFocus = Props.autoFocus;
      var className = Props.className;
      var disabledOpt = Props.disabled;
      var onBlur = Props.onBlur;
      var onChange = Props.onChange;
      var onFocus = Props.onFocus;
      var onKeyPress = Props.onKeyPress;
      var placeholder = Props.placeholder;
      var requiredOpt = Props.required;
      var rows = Props.rows;
      var testId = Props.testId;
      var validationStatus = Props.validationStatus;
      var value = Props.value;
      var disabled = disabledOpt !== undefined ? disabledOpt : false;
      var required = requiredOpt !== undefined ? requiredOpt : false;
      var match = Curry._2(BrowserStyle.Input.useInput(onFocus)(disabled), onBlur, Relude_Option.map((function (param) {
                  return Relude_Result.map((function (prim) {
                                
                              }), param);
                }), validationStatus));
      var tmp = {
        onBlur: match.onBlur,
        onChange: onChange,
        onFocus: match.onFocus,
        required: required,
        styleType: match.styleType,
        value: value
      };
      if (autoFocus !== undefined) {
        tmp.autoFocus = Caml_option.valFromOption(autoFocus);
      }
      if (className !== undefined) {
        tmp.className = Caml_option.valFromOption(className);
      }
      if (onKeyPress !== undefined) {
        tmp.onKeyPress = Caml_option.valFromOption(onKeyPress);
      }
      if (placeholder !== undefined) {
        tmp.placeholder = Caml_option.valFromOption(placeholder);
      }
      if (rows !== undefined) {
        tmp.rows = Caml_option.valFromOption(rows);
      }
      if (testId !== undefined) {
        tmp.testId = Caml_option.valFromOption(testId);
      }
      var tmp$1 = Relude_Option.map((function (prim) {
              return prim;
            }), (ref_ == null) ? undefined : Caml_option.some(ref_));
      if (tmp$1 !== undefined) {
        tmp.ref = Caml_option.valFromOption(tmp$1);
      }
      return React.createElement(make, tmp);
    });

var BaseStatefulStyleType = {
  make: make$1
};

var make$2 = React.forwardRef(function (Props, ref_) {
      var autoFocus = Props.autoFocus;
      var className = Props.className;
      var disabledOpt = Props.disabled;
      var iconLeft = Props.iconLeft;
      var iconRight = Props.iconRight;
      var inputClassName = Props.inputClassName;
      var onBlur = Props.onBlur;
      var onChange = Props.onChange;
      var onFocus = Props.onFocus;
      var onKeyPress = Props.onKeyPress;
      var placeholder = Props.placeholder;
      var requiredOpt = Props.required;
      var rows = Props.rows;
      var size = Props.size;
      var testId = Props.testId;
      var title = Props.title;
      var validationStatus = Props.validationStatus;
      var value = Props.value;
      var disabled = disabledOpt !== undefined ? disabledOpt : false;
      var required = requiredOpt !== undefined ? requiredOpt : false;
      var tmp = {
        children: {
          TAG: /* Input */1,
          _0: (function (param) {
              var tmp = {
                onBlur: param.onBlur,
                onChange: onChange,
                onFocus: param.onFocus,
                required: required,
                styleType: param.styleType,
                value: value
              };
              if (autoFocus !== undefined) {
                tmp.autoFocus = Caml_option.valFromOption(autoFocus);
              }
              if (inputClassName !== undefined) {
                tmp.className = Caml_option.valFromOption(inputClassName);
              }
              if (onKeyPress !== undefined) {
                tmp.onKeyPress = Caml_option.valFromOption(onKeyPress);
              }
              if (placeholder !== undefined) {
                tmp.placeholder = Caml_option.valFromOption(placeholder);
              }
              if (rows !== undefined) {
                tmp.rows = Caml_option.valFromOption(rows);
              }
              if (testId !== undefined) {
                tmp.testId = Caml_option.valFromOption(testId);
              }
              var tmp$1 = Relude_Option.map((function (prim) {
                      return prim;
                    }), (ref_ == null) ? undefined : Caml_option.some(ref_));
              if (tmp$1 !== undefined) {
                tmp.ref = Caml_option.valFromOption(tmp$1);
              }
              return React.createElement(make, tmp);
            })
        },
        disabled: disabled
      };
      if (className !== undefined) {
        tmp.className = Caml_option.valFromOption(className);
      }
      if (iconLeft !== undefined) {
        tmp.iconLeft = Caml_option.valFromOption(iconLeft);
      }
      if (iconRight !== undefined) {
        tmp.iconRight = Caml_option.valFromOption(iconRight);
      }
      if (onBlur !== undefined) {
        tmp.onBlur = Caml_option.valFromOption(onBlur);
      }
      if (onFocus !== undefined) {
        tmp.onFocus = Caml_option.valFromOption(onFocus);
      }
      if (size !== undefined) {
        tmp.size = Caml_option.valFromOption(size);
      }
      if (title !== undefined) {
        tmp.title = Caml_option.valFromOption(title);
      }
      if (validationStatus !== undefined) {
        tmp.validationStatus = Caml_option.valFromOption(validationStatus);
      }
      return React.createElement(BrowserComponents_Field.make, tmp);
    });

exports.Base = Base;
exports.BaseStatefulStyleType = BaseStatefulStyleType;
exports.make = make$2;
/* make Not a pure module */
